import React from 'react'
import { Routes, Route } from 'react-router-dom'

import { RegistrationContainer } from '../../components/RegistrationContainer'
import { PaginationProvider } from '../../contexts/PaginationContext'
import { useBreadcrumb } from '../../hooks/useBreadcrumb'

import { PeopleTable, PersonForm } from './components'

export const People: React.FC = () => {
  const breadcrumb = useBreadcrumb({
    pessoas: 'Pessoas',
    inclusao: 'Inclusão',
    edicao: 'Edição'
  })

  return (
    <RegistrationContainer breadcrumbItems={breadcrumb}>
      <PaginationProvider>
        <Routes>
          <Route path="/" element={<PeopleTable />} />
          <Route path="/inclusao" element={<PersonForm />} />
          <Route path="/edicao" element={<PersonForm />} />
        </Routes>
      </PaginationProvider>
    </RegistrationContainer>
  )
}
